var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"baseModal"},[_c('div',{staticClass:"baseModal__overlay",on:{"click":function($event){return _vm.$emit('closeModal')}}}),_vm._v(" "),_c('div',{staticClass:"baseModal__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }